import { i18n } from "discourse-i18n";
import CircleMembersRoute from "./members";

export default class CircleStaffRoute extends CircleMembersRoute {
  templateName = "circle/members";

  titleToken() {
    return i18n("discourse_circles.circle.staff.title_token", {
      circle_name: this.modelFor("circle").name,
    });
  }

  get mode() {
    return "staff";
  }

  get group() {
    return this.circle?.staff_group;
  }
}
